import axios from "axios"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL

export const getSchoolInfoApi = async (payload) => {
    try {

        let apiToken = JSON.parse(localStorage.getItem("Token"))
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.get(`${liveApiUrl}/api/dashboard/get-school-info`, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error While Getting School Info:", error)
        throw error
    }
}
